import type {
    LeadsColumnsConfigDto,
    LeadsSelectedColumnsRequestDto,
    LeadsType,
} from "app/pages/sales-intelligence/modules/leads-search";
import type { TagColumnValue, TagColumnValueResponse } from "app/pages/sales-intelligence/modules/lists/types/columns";
import type { GetRequestOptions, IFetchService } from "app/services/fetchService";

const BASE_ENDPOINT_PATH = "/sales-api/opportunities";
const TAGS_ENDPOINT_PATH = "/sales-api/opportunities-list";

const createListColumnsApiService = (fetchService: IFetchService) => {
    return {
        fetchColumnConfig(options?: Readonly<GetRequestOptions>): Promise<LeadsColumnsConfigDto> {
            return fetchService.get(`${BASE_ENDPOINT_PATH}/description/columns`, undefined, options);
        },

        saveColumnSelection(dto: Readonly<LeadsSelectedColumnsRequestDto>, leadType: LeadsType): Promise<void> {
            return fetchService.put(`${BASE_ENDPOINT_PATH}/description/${leadType}/columns/selection`, dto);
        },

        fetchTags(listId: string, options?: Readonly<GetRequestOptions>): Promise<readonly TagColumnValueResponse[]> {
            return fetchService.get(`${TAGS_ENDPOINT_PATH}/${listId}/tags`, undefined, options);
        },

        setTag(listId: string, tagId: string, domain: string): Promise<void> {
            return fetchService.post(`${TAGS_ENDPOINT_PATH}/${listId}/tags/${tagId}/set`, { Domain: domain });
        },
        setTagCRM(listId: string, tagId: string, domain: string): Promise<void> {
            return fetchService.post(`/sales-api/crm-list/${listId}/tags/${tagId}/set`, { Domain: domain });
        },

        createTag(listId: string, tagTitle: string, colorHex?: string): Promise<TagColumnValue> {
            return fetchService.post(`${TAGS_ENDPOINT_PATH}/${listId}/tags`, { Title: tagTitle, ColorHex: colorHex });
        },

        updateTag(listId: string, tag: TagColumnValueResponse): Promise<void> {
            const { Id, Title, ColorHex } = tag;
            return fetchService.patch(`${TAGS_ENDPOINT_PATH}/${listId}/tags/${Id}`, { Title, ColorHex });
        },

        deleteTag(listId: string, tagId: string): Promise<void> {
            return fetchService.delete(`${TAGS_ENDPOINT_PATH}/${listId}/tags/${tagId}`);
        },
    };
};

export default createListColumnsApiService;
